import { useQuestionnaireFormContext, type QuestionnaireFormContextType } from '@/components/Questionnaire/QuestionnaireProvider';
import { useEffect } from 'react';

type Props = {
  fromContext: QuestionnaireFormContextType;
};

const TransferData: React.FC<Props> = ({ fromContext }) => {
  const toContext = useQuestionnaireFormContext();

  useEffect(() => {
    toContext.mergeResponseSources(fromContext.getBulkResponseSources());
    toContext.mergeAiRequestIds(fromContext.getBulkAiRequestIds());
  }, [fromContext, toContext]);

  return null;
};

export default TransferData;